import globalActions from '@/actions'
import $command from '@/utils/command'
const state = {
	path: '',
	docs: []
}
const mutations = {
	update: (state, {path, docs}) => {
		state.path = path
		state.docs = docs
	}
}
const actions = {
	async get({
		commit
	}, path) {
		if (!path)
			return state;
		if (state.path == path && state.docs.length > 0)
			return state;

		let result = await $command.execute({
			api: "/csl-merch-api/helperDoc/getHelperDocList",
			parameter: {
				route: path
			}
		})
		
		commit('update', {path, docs:result.data})
		return state;
	},
}
export default {
	namespaced: true,
	mutations,
	state,
	actions
}